import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { cn } from '@ridemaadi/utils';
import { useRideMode } from '../../features/rides/rideMode/useRideMode';

/** Header notification bell - alerts during ride mode and normal mode. */
export function HeaderNotificationBell() {
  const { unreadAlerts, markAlertsSeen, isRideMode } = useRideMode();
  const showBadge = unreadAlerts > 0 || isRideMode;

  return (
    <Link
      to="/notifications"
      onClick={markAlertsSeen}
      className={cn(
        'relative flex min-h-touch min-w-touch shrink-0 items-center justify-center rounded-lg text-muted transition hover:bg-surface-alt hover:text-primary',
      )}
      aria-label={
        showBadge
          ? `Alerts, ${unreadAlerts || 1} unread notification${unreadAlerts === 1 ? '' : 's'}`
          : 'Alerts'
      }
    >
      <Bell className="h-5 w-5" aria-hidden />
      {showBadge && (
        <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-fg">
          {unreadAlerts > 0 ? unreadAlerts : 1}
        </span>
      )}
    </Link>
  );
}
